import { render, staticRenderFns } from "./userRequiredLeaves.vue?vue&type=template&id=881513b0&"
import script from "./userRequiredLeaves.vue?vue&type=script&lang=js&"
export * from "./userRequiredLeaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports